import React from 'react';

import {
  Webform,
} from '@uncinc/react-drupal-core';

import { WebformProcessedText } from '../../../components';
import useClasses from '../../../hooks/useClasses';
import { ImmutableParagraphWebformEntity } from '..';

interface Props {
  entity: ImmutableParagraphWebformEntity;
}

const ParagraphWebform: React.FC<Props> = ({ entity }) => {
  const { buildClass } = useClasses('ParagraphWebform');

  const webformID = entity.getIn(['field_webform', 0, 'target_id']);

  // TODO: configure webform behaviour based on design and override
  // webform components if needed
  return (
    <div className={buildClass()}>
      <Webform
        id={webformID}
        overriddenComponents={{
          processed_text: WebformProcessedText,
        }}
      />
    </div>
  );
};

export default ParagraphWebform;
